export default __webpack_public_path__ + "static/media/lisopresol.56cea768.jpg";